import { render, staticRenderFns } from "./RelatedAditionalsPanelReceivable.vue?vue&type=template&id=00c5b004&scoped=true"
import script from "./RelatedAditionalsPanelReceivable.vue?vue&type=script&lang=js"
export * from "./RelatedAditionalsPanelReceivable.vue?vue&type=script&lang=js"
import style0 from "./RelatedAditionalsPanelReceivable.vue?vue&type=style&index=0&id=00c5b004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5b004",
  null
  
)

export default component.exports